module.exports = __webpack_public_path__ + "static/media/dashBackground.1e224271.png";